import { productFilters } from 'components/Blotters/Filter/BlotterFilterNext.helpers';
import type { AddonManagementFilters } from 'state/workspaces/addonManagement/addonManagement.model';
import { initialAddonManagementFilters } from 'state/workspaces/addonManagement/addonManagement.model';

import type { FilterPayload } from '../../../../apiConnector/blotters';

export function toFilterState(response: FilterPayload | undefined): AddonManagementFilters {
  if (!response || !response.data) {
    return initialAddonManagementFilters;
  }

  switch (response.version) {
    case 1:
      return sanitizeFiltersProperties(response.data as AddonManagementFilters, initialAddonManagementFilters);
    default:
      return initialAddonManagementFilters;
  }
}

function sanitizeFiltersProperties(
  data: AddonManagementFilters,
  defaultValue: AddonManagementFilters,
): AddonManagementFilters {
  if (!data) {
    return defaultValue;
  }

  if (data.productFilter === undefined || !productFilters.includes(data.productFilter)) {
    data.productFilter = 'allProducts';
  }

  return { ...defaultValue, ...data };
}
